import React from 'react';
import Graph from './graph/Graph';
import EditorSidebar from './sidebar/EditorSidebar';
import UpdateCircle from './update-circle/UpdateCircle';
import UserPresence from './user-presence/UserPresence';
import { useCurrentBoard } from '../../services/state';
import Header from './header/EditorHeader';
import { useBoardRecord } from '../../services/deepstream';
import { LoadingSpinner } from '../common/loading-spinner/LoadingSpinner';

import '../../App.css';

const Editor = () => {
  const { ready } = useBoardRecord();
  const { userRole } = useCurrentBoard();

  const canEditBoard = ['editor', 'owner'].includes(userRole);

  if (!ready) {
    return (
      <div style={{ textAlign: 'left' }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="content-wrapper">
        <div id="circlyapp-editor-canvas" className="App">
          {canEditBoard && <EditorSidebar />}
          <Graph />

          <UpdateCircle />

          <UserPresence />
        </div>
      </div>
    </>
  );
};

export default Editor;
